const Size = {
    homePage:{
        Intro:"25px",
        xpass:"75px",
        text:"14px",
        letterSpacing:"20"
    },
    homePg_Media:{
        intro:"20px",
        xpass:"50px",
        text:"14px",
        letterSpacing:"2"
    },

    inputSize:{
        padding:"10px 14px",
        radius:"6px",
        width:""
    }
}

export default Size